<template>
  <div class="list-box">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="发票审批"
    >
      <el-segmented
        v-model="state.params.is_approve"
        :props="{
          label: 'Text',
          value: 'Key',
        }"
        :options="[
          { Key: 0, Text: '待审批' },
          { Key: 1, Text: '已审批' },
        ]"
        :empty-values="[null, undefined, 0]"
        class="c-segmented"
        @change="onLoad()"
      />
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg">
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="状态" label2="类型" />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <c_status
                  arrName="Meeting_Invoice_Status"
                  :value="row.status"
                  :key="row.status"
                />
              </template>
              <template #bottom>
                <c_status
                  arrName="Invoice_Type"
                  :value="row.invoice_type"
                  :key="row.invoice_type"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="发票抬头"
              label2="纳税人识别号"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value1="row.invoice_title" :value2="row.tax_no" />
          </template>
        </el-table-column>
        <!-- <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="会议名称" label2="地址" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.meeting?.name"
              :value2="row.meeting?.address"
            />
          </template>
        </el-table-column> -->
        <el-table-column :width="300">
          <template #header>
            <div
              class="c-table-col-header"
              label1="会议名称"
              label2="会议时间"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value2="row.meeting?.start_date + ' ~ ' + row.meeting?.end_date"
            >
              <template #top>
                <div
                  class="flex items-center gap-x-2 text-green-700 cursor-pointer hover:underline"
                  @click="
                    $openMenu({
                      path: 'HuiYiDetail',
                      title: '会议详情-' + row.meeting?.name,
                      refresh: true,
                      data: {
                        id: row.meeting?.id,
                      },
                    })
                  "
                >
                  <strong>
                    {{ row.meeting?.name + "[" + row.meeting?.number + "]" }}
                  </strong>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="amount"
          label="开票金额"
          :formatter="$tab_MoneyFormat"
        />
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="发票号" label2="开票日期" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.invoice_no || '-'"
              :value2="row.invoice_date || ''"
            />
          </template>
        </el-table-column>
        <el-table-column label="创建信息">
          <template #default="{ row }">
            <c_tabgroup :value2="row.create_time">
              <template #top>
                <text>
                  {{ row.add_admin_name }}
                </text>
                <text class="text-xs text-gray-400">
                  {{ "/" + row.add_department_name }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="260">
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Select"
              link
              @click.stop="
                state.selectId = row.id;
                state.showDetail = true;
              "
              v-if="row.status === 0"
              >审批
            </el-button>
            <el-button
              type="success"
              :icon="Search"
              link
              @click.stop="
                state.selectId = row.id;
                state.showDetail = true;
              "
              v-else
              >查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showDetail"
    title="发票审批"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showDetail = false;
      }
    "
    style="width: 50%"
  >
    <c_detail
      :id="state.selectId"
      :search="state.search"
      @close="
        state.showDetail = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meetinginvoice_page } from "@/http/fapiaoshenpi";

import c_detail from "./Detail";

class InitFormData {
  params = {
    page: 1,
    is_approve: 0,
  };
}

export default {
  components: {
    c_detail,
  },
  props: {
    params: Number,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meetinginvoice_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.list_data = list;
          state.totalCount = count;
        }
      });
    };

    return { state, props, onLoad };
  },
};
</script>

<style lang="less" scoped></style>
